import { render, staticRenderFns } from "./NoticeMostViews.vue?vue&type=template&id=4e421ece"
import script from "./NoticeMostViews.vue?vue&type=script&lang=js"
export * from "./NoticeMostViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports